$(document).ready(function(){
	init(); 
	$(window).trigger('resize');
	$(window).trigger('scroll');
});

function init() {
	//Lazyload Images
	$(window).on('load scroll resize', function() {
		$('.u__object-fit:visible').each(function() {
			if ( isVisible($(this)) ) {
				if ( $(this).data('srcset') ) {
					$(this).attr('srcset', $(this).data('srcset'));
					$(this).removeAttr('data-srcset');
				}

				if ( $(this).data('src') ) {
					$(this).attr('src', $(this).data('src'));
					$(this).removeAttr('data-src');
				}			
			}
		});	
	});

	function isVisible(elem) {
		var scrollTop = $(window).scrollTop();
		var windowBottom = scrollTop + $(window).height();
		var offset = 100;
		var elementTop = elem.offset().top;

		if ( (windowBottom + offset) > elementTop ) {
			return true;
		} else {
			return false;
		}
	}	

	$('.js__hamburger-trigger').on('click', function(e) {
		e.preventDefault();

		$(this).toggleClass('active');
		$('.m__header').toggleClass('nav-open');
	});

	$(window).on('scroll', function() {
		var headerHeight = $('.m__header').height() + 1;

		if ( $(window).scrollTop() > headerHeight ) {
			$('.m__header').css({'transform' : 'translateY(-' + headerHeight +'px)'});
		} else {
			$('.m__header').removeAttr('style'); 
		}

		if ( $(window).scrollTop() > 150 ) {
			$('.m__header').addClass('sticky');
		} else {
			$('.m__header').removeClass('sticky');
		}		

		if ( $(window).scrollTop() > 275 ) {
			$('.m__header').addClass('slide-down');
		} else {
			$('.m__header').removeClass('slide-down');
		}
	});

	$('.m__header .nav-col .m__header-nav ul .menu-item.menu-item-has-children>a').on('click', function(e) {
		if ( $(window).width() < 992 ) {
			if ( !$(this).hasClass('clicked-once') ) {
				e.preventDefault();

				$(this).siblings('.sub-menu').slideDown();

				$(this).addClass('clicked-once');
			}
		}
	});

	if ( $('.js__restaurants-slider').length ) {
		var arrow = '/wp-content/themes/cafemurano/library/images/icons/next-arrow.svg';

		$restaurant_slider = $('.js__restaurants-slider');
		settings = {
			slidesToShow: 4,
			slidesToScroll: 1,
			dots: false,
			arrows: true,
			swipe: true,
			nextArrow: "<div class='slick-arrow slick-next' style='background-image: url("+ arrow +");'></div>",
			prevArrow: "<div class='slick-arrow slick-prev' style='background-image: url("+ arrow +");'></div>",
			responsive: [{
				breakpoint: 992,
				settings: {
					slidesToShow: 3
				}
			}]			
		};
		$restaurant_slider.slick(settings);

		// reslick only if it's not slick()
		$(window).on('resize', function() {
			if ( $(window).width() < 768 ) {
				if ($restaurant_slider.hasClass('slick-initialized')) {
					$restaurant_slider.slick('unslick');
				}
				return;
			}

			if ( $(window).width() > 768 ) {
				if (!$restaurant_slider.hasClass('slick-initialized')) {
					return $restaurant_slider.slick(settings);
				}
			}
		});		
	}

	//Popups
	$('.popup').addClass('loaded');
	$(document).on('click', '.js__popup-trigger', function(e) {
		e.preventDefault();

		$('.popup').removeClass('no-bg');

		var popup = $(this).data('popup');

		$('.popup .popup__item').removeClass('showing');
		$('.popup .popup__header').show();
		$('html, body').css('overflow', 'hidden');

		$('.popup').addClass('open');
		$('.popup .popup__item#'+popup).addClass('open showing');
	});	

	// Custom Popup
	function getCookie(cname) {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');

		for (var i = 0; i <ca.length; i++) {
			var c = ca[i];

			while (c.charAt(0) == ' ') {
		  		c = c.substring(1);
			}

			if (c.indexOf(name) == 0) {
		  		return c.substring(name.length, c.length);
			}
		}
		return false;
	}

	var popupCookie = getCookie('hide_closure_popup');

	if ( $('.popup').data('custom-popup') == 'show' && popupCookie != 'yes' ) {
		$('.popup').addClass('no-bg');

		setTimeout(function() {
			var popup = 'custom';

			$('.popup .popup__item').removeClass('showing');
			$('.popup .popup__header').hide();
			$('html, body').css('overflow', 'hidden');

			$('.popup').addClass('open');
			$('.popup .popup__item#'+popup).addClass('open showing');
			
			$('.js__popup-slider').slick({
				arrows: false,
				dots: true,
				autoplay: true,
				autoplaySpeed: 8000
			});
		}, 2500);

	}

	$('.js__popup-close').on('click', function(e) {
		e.preventDefault();

		if ( $(this).data('cookie') == 'set' ) {
			setCookie('hide_closure_popup', 'yes');
		}

		$('.popup').removeClass('open');	
		$('.popup .popup__item').removeClass('open');
		$('html, body').removeAttr('style');
	});

	function setCookie(cname, cvalue) {
	    var date = new Date();
	    var expires = 'expires=';
	    date.setDate(date.getDate() + 1);
	    expires += date.toGMTString();
	    document.cookie = cname + '=' + cvalue + '; ' + expires + '; path=/';
	}	

	//Selectric
	$('.js__selectric').selectric();

	//Pikaday
	function formatDate(number) {
		if ( number < 10 ) {
			return '0' + number;
		} else {
			return number;
		}
	}

	var x = 1; $('.js__pikaday-trigger').each(function() {
		$(this).attr('id', 'date-trigger-'+x);
		var bookingDate = new Pikaday({
		    field: document.getElementById('date-trigger-'+x),
		    format: 'DD/MM/YYYY',    
		    minDate: new Date(),
		    onSelect: function(date) {
		        var day = date.getDate();
		        var month = formatDate(date.getMonth() + 1);
		        var year = formatDate(date.getFullYear());

		        var arrivalDate = year + '-' + month + '-' + day;

		        $('#bookingForm input#date').val(arrivalDate);    	
			}
		});	
		x++;
	});	

	//Booking Form
	$('#bookingForm').on('submit', function(e) {
		e.preventDefault();

		// Clear previous error messages
		// var errorCount = 0;
		// $(this).find('.popup__item-form-label--error').hide();

		// var restref = $(this).find('#location').find(':selected').val();
		// var restaurant = $(this).find('#location').find(':selected').data('restaurant');
  		// var selectedDate = $(this).find('#date').val();
  		// var selectedTime = $(this).find('#booking_time').find(':selected').val();
  		// var time = selectedTime.replace(':', '%3A');
  		// var selectedPeople = $(this).find('#people').find(':selected').val();

  		// if ( restref == 0 ) {
  		// 	$(this).find('.popup__item-form-label--error').show();
  		// 	errorCount = 1;
  		// }

		// var otURL = 'https://www.opentable.co.uk/restaurant/profile/';
  		// otURL += restref + '/reserve/';
  		// otURL += '?covers=' + selectedPeople;
  		// otURL += '&datetime=' + selectedDate + 'T' + time;
  		// otURL += '&restref=' + restref;

        // if ( errorCount === 0 ) {
        // 	window.open(otURL, '_blank');
        // }

        var sevenRoomsLink = $(this).find('#location').find(':selected').val();
        window.open(sevenRoomsLink, '_blank');
	});	

	//Hero Section - Module
	if ( $('.module-1 .hero__promo').length ) {
		$(window).on('resize', function() {
			var windowHeight = $(window).height();
			var promoHeight = $('.module-1 .hero__promo').outerHeight();
			var heroSliderHeight = windowHeight - promoHeight;
			
			$('.module-1 .hero__slider-container').css('height', heroSliderHeight+'px');
		});
	}

	if ( $('.js__hero-slider').length ) {
		var i = 1; $('.js__hero-slider').each(function() {
			$(this).addClass('js__hero-slider-'+i);

			$('.js__hero-slider-'+i).slick({
				autoplay: false,
				autoplaySpeed: 7000,
				speed: 1000,
				arrows: false,
				dots: false,
				fade: true
			});

			if ( $('body').hasClass('home') ) {
				$('.a__hero-image-animation, .a__hero-animation').addClass('loaded');
				$('.js__hero-slider-'+i+' .hero__slide').removeClass('hero__slide--hidden');
				$('.js__hero-slider-'+i).slick('slickSetOption', 'autoplay', true, true);
				$('.js__hero-slider-'+i).slick('slickSetOption', 'autoplaySpeed', 4000, true);
			}			

			i++;
		});
	}

	// Full Screen Text - Module
	if ( $('.full-screen-text__section.module-1').length ) {
		if ( $(window).width() > 991 ) {
			var lines = $('.full-screen-text__section.module-1 .text__content p').length;

			var i = 1; $('.full-screen-text__section.module-1 .text__content p').each(function() {
				var content = $(this).html();

				$(this).html('<span class="inner">'+content+'</span>');

				if ( i === lines ) {
					addLoadedClass(lines);
				}

				i++;
			});
		}
	}

	function addLoadedClass(lines) {
		setTimeout(function(){
			$('.full-screen-text__section.module-1 .text__content').addClass('loaded');

			if ( $('.full-screen-text__section.module-1 .text__small-text').length ) {
				var transitionDelay = (lines * 0.1) + 0.6;
				$('.full-screen-text__section.module-1 .text__small-text .inner').css('transition-delay', transitionDelay+'s');
				$('.full-screen-text__section.module-1 .text__small-text').addClass('loaded');
			}
		}, 400);
	}

	// CTA Block 2 Columns - Module
	if ( $('.cta__block-2-cols').length ) {
		var i = 1; $('.cta__block-2-cols').each(function() {
			$(this).addClass('cta__block-2-cols-'+i);

			$('.cta__block-2-cols-'+i+' .cta__title').matchHeight();
			$('.cta__block-2-cols-'+i+' .cta__description').matchHeight();

			i++;
		});
	}	

	// Menu Links - Module
	if ( $('.js__menu__link-slider').length ) {
		var i = 1; $('.js__menu__link-slider').each(function() {
			$(this).addClass('js__menu__link-slider-'+i);

			$('.js__menu__link-slider-'+i).slick({
				autoplay: false,
				arrows: false,
				dots: false,
				fade: true,
				draggable: false,
				swipe: false,
				speed: 750
			});

			$('.js__menu__link-slider-nav').on('mouseover', function() {
				var slideID = $(this).data('slide-id');
				var slider = $(this).parentsUntil('.menu__links').find('.js__menu__link-slider');

				slider.slick('slickGoTo', slideID, false);
			});

			i++;
		});
	}	

	// Content Block - Module
	if ( $('.js__content-block-slider').length ) {
		var nextArrow = '/wp-content/themes/cafemurano/library/images/icons/next-arrow-gold-bg.svg';		
		var prevArrow = '/wp-content/themes/cafemurano/library/images/icons/prev-arrow-gold-bg.svg';

		var i = 1; $('.js__content-block-slider').each(function() {
			$(this).addClass('js__content-block-slider-'+i);
			
			var slidesToShow = $(this).data('slides-to-show');

			$('.js__content-block-slider-'+i).slick({
				autoplay: false,
				slidesToShow: slidesToShow,
				arrows: true,
				dots: false,
				speed: 750,
				nextArrow: "<div class='slick-arrow slick-next' style='background-image: url("+ nextArrow +");'></div>",
				prevArrow: "<div class='slick-arrow slick-prev' style='background-image: url("+ prevArrow +");'></div>"				
			});

			i++;
		});
	}

	$('.js__change-content-block-tab').on('click', function(e) {
		e.preventDefault();
		if ( !$(this).hasClass('active') ) {
			var rowIndex = $(this).data('row-index');

			$('.js__change-content-block-tab').removeClass('active');
			$(this).addClass('active');

			var content = $('.content__block-container');

			// Set min height for the content
			var minHeight = content.outerHeight();
			content.css('min-height', minHeight+'px');
			content.addClass('fading-out');

			
			setTimeout(() => {
				$('.content__block-row-wrapper').removeClass('active');
				$('.content__block-row-wrapper[data-row-index="'+rowIndex+'"]').addClass('active');
	            content.removeAttr('style');
	            content.removeClass('fading-out');
			}, 450);
		}
	});

	// Menus Inline - Module
	if ( $('.js__menu-locations-slider').length ) {
		var initialSlide = $('.js__menu-locations-slider .menu__location-div .menu__location.active').data('index');

		$menu_location_slider = $('.js__menu-locations-slider');
		settings = {
			initialSlide: initialSlide,
			slidesToShow: 4,
			dots: false,
			arrows: false,
			swipe: true,		
			centerMode: false,
			responsive: [{
				breakpoint: 991, 
				settings: {
					slidesToShow: 4,
				},
				breakpoint: 767,
				settings: {
					slidesToShow: 3,
				},
				breakpoint: 575,
				settings: {
					slidesToShow: 1,
				}			
			}]			
		};
		$menu_location_slider.slick(settings);

		// reslick only if it's not slick()
		$(window).on('resize', function() {
			if ( $(window).width() > 991 ) {
				if ($menu_location_slider.hasClass('slick-initialized')) {
					$menu_location_slider.slick('unslick');
				}
				return;
			}

			if ( $(window).width() < 991 ) {
				if (!$menu_location_slider.hasClass('slick-initialized')) {
					return $menu_location_slider.slick(settings);
				}
			}
		});		
	}		
	
	$('.js__menu-location-trigger').on('click', function(e) {
		e.preventDefault();

		if ( !$(this).hasClass('active') ) {
			var restaurant = $(this).data('menu-location');

			$('.js__menu-location-trigger').removeClass('active');
			$('.js__menu-location-trigger[data-menu-location='+restaurant+']').addClass('active');

           	ajaxMenus(restaurant, '', 'no');
		}
	});

	$(document).on('click', '.js__change-menu', function(e) {
		e.preventDefault();

		if ( !$(this).hasClass('active') ) {
			var menuID = $(this).data('menu-id');
			var restaurant = $('.js__menu-location-trigger.active').data('menu-location');

			$('.js__change-menu').removeClass('active');
			$(this).addClass('active');

	       	ajaxMenus(restaurant, menuID, 'yes');
		}
	});	

	$(document).on('change', '.menu__list-dropdown', function(e) {
		var restaurant = $('.js__menu-location-trigger.active').data('menu-location');
		var menuID = $(this).val();

		ajaxMenus(restaurant, menuID, 'yes');
	});

	function ajaxMenus(restaurant, menuID, sameLocation) {
		var content = $('#menus_ajax_container');

	    // Set min height for the content
	    var minHeight = content.outerHeight();
	    content.css('min-height', minHeight+'px');	

	    $.ajax({
	        type: 'POST',
	        dataType: 'html',
	        url: main__js_vars.ajaxurl,
	        data: {
	            'restaurant': restaurant,
	            'menuID': menuID,
	            'action': 'ajax_menu_location'
	        },
	        beforeSend : function () {
	            content.addClass('fading-out');
	            $('.menus__list-container').addClass('fading-out');
	        },
	        success: function (data) {
	            var returnedData = JSON.parse(data);

	            if ($(returnedData.menus).length) {
	            	if ( sameLocation == 'no' ) {
		                $('.menus__list-container .menu__list').remove();
		                $('.menus__list-container').append($(returnedData.menus_list));
	            	}
	                $('#menus_ajax_container .menu').remove();
	                $.when($('#menus_ajax_container .menu').remove()).then(content.append($(returnedData.menus)));
	            }

	            content.removeAttr('style');                    
	            content.removeClass('fading-out');
	            $('.menus__list-container').removeClass('fading-out');
	        },
	        error : function (jqXHR, textStatus, errorThrown) {
	            $(this).html($.parseJSON(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
	            console.log(jqXHR);
	        },
	    }); 
	}

	// Gift - Module

	//Changing gifts shown by clicking the nav
	$('.js__change-gift-type').on('click', function(e) {
		e.preventDefault();

		if ( !$(this).hasClass('active') ) {
			var giftTypeID = $(this).data('gift-type-id');

			$('.js__change-gift-type').removeClass('active');
			$(this).addClass('active');

			ajaxGifts(giftTypeID);
		}
	});

	//Check the URL to see if we need to show a certain category on page load
	if(getParameterByName('gift-id') > ''){
		var giftTypeID = getParameterByName('gift-id');

		$('.js__change-gift-type').removeClass('active');
		$('.js__change-gift-type').each(function(){
			if($(this).data('gift-type-id') == giftTypeID){
				$(this).addClass('active');
			}
		})

		ajaxGifts(giftTypeID);
	}

	function ajaxGifts(giftTypeID) {
		var content = $('#ajax_gifts_container');

	    // Set min height for the content
	    var minHeight = content.outerHeight();
	    content.css('min-height', minHeight+'px');	

	    $.ajax({
	        type: 'POST',
	        dataType: 'html',
	        url: main__js_vars.ajaxurl,
	        data: {
	            'giftTypeID': giftTypeID,
	            'action': 'ajax_gifts'
	        },
	        beforeSend : function () {
	            content.addClass('fading-out');
	        },
	        success: function (data) {
	            var returnedData = JSON.parse(data);

	            $('#ajax_gift_type_content .gift__type-content').remove();
	            $('#ajax_gift_type_content').append($(returnedData.gift_type));
	            $('#ajax_gifts_content .row').remove();
	            $.when($('#ajax_gifts_content .row').remove()).then($('#ajax_gifts_content').append($(returnedData.gifts)));

	            content.removeAttr('style');                    
	            content.removeClass('fading-out');
	        },
	        error : function (jqXHR, textStatus, errorThrown) {
	            $(this).html($.parseJSON(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
	            console.log(jqXHR);
	        },
	    }); 
	}	





	$('.js__change-restaurant').on('click', function(e) {
		e.preventDefault();

		if ( !$(this).hasClass('active') ) {
			var restaurantID = $(this).data('restaurant-id');

			$('.js__change-restaurant').removeClass('active');
			$(this).addClass('active');

			ajaxPrivateDining(restaurantID, false);
		}
	});

	changePrivateDiningArea();

	function changePrivateDiningArea() {
		$('.js__change-pd-area').on('click', function(e) {
			e.preventDefault();
	
			if ( !$(this).hasClass('active') ) {
				var restaurantID = $(this).data('restaurant-id');
	
				$('.js__change-pd-area').removeClass('active');
				$(this).addClass('active');
	
				ajaxPrivateDining(restaurantID, true);
			}
		});
	}

	function ajaxPrivateDining(restaurantID, changeArea) {
		var elem = changeArea ? $('.js__change-pd-area.active[data-restaurant-id="'+restaurantID+'"]') : $('.js__change-restaurant[data-restaurant-id="'+restaurantID+'"]');
		var showSecondaryNav = elem.data('show-secondary-nav');
		var content = $('#ajax_pd_container');

	    // Set min height for the content
	    var minHeight = content.outerHeight();
	    content.css('min-height', minHeight+'px');	

	    $.ajax({
	        type: 'POST',
	        dataType: 'html',
	        url: main__js_vars.ajaxurl,
	        data: {
	            'restaurantID': restaurantID,
				'areaIndex': changeArea ? elem.data('pd-area-index') : 1,
	            'action': 'ajax_private_dining'
	        },
	        beforeSend : function () {
	            content.addClass('fading-out');

				if ( !changeArea ) {					
					if ( !$('.restaurants-secondary-nav').hasClass('d-none') ) {					
						if ( !showSecondaryNav ) {
							$('.restaurants-secondary-nav').addClass('fading-out');
						} else {
							$('.restaurants-pd-areas').addClass('fading-out');
						}
					}
				}
	        },
	        success: function (data) {
	            var returnedData = JSON.parse(data);
				
				if ( !changeArea ) {
					if ( !showSecondaryNav ) {
						$('.restaurants-secondary-nav').addClass('d-none');
						$('.restaurants-secondary-nav').removeClass('fading-out');
					}
				}

	            $('#ajax_pd_container .content__block-row').remove();
	            $.when($('#ajax_pd_container .content__block-row').remove()).then($('#ajax_pd_container').append($(returnedData.private_dining_info)));

				if ( !changeArea && returnedData.pd_secondary_nav ) {
					$('.restaurants-pd-areas').html(returnedData.pd_secondary_nav)
				}

				var nextArrow = '/wp-content/themes/cafemurano/library/images/icons/next-arrow-gold-bg.svg';		
				var prevArrow = '/wp-content/themes/cafemurano/library/images/icons/prev-arrow-gold-bg.svg';

				$('.js__content-block-slider').slick({
					autoplay: false,
					slidesToShow: 1,
					arrows: true,
					dots: false,
					speed: 750,
					nextArrow: "<div class='slick-arrow slick-next' style='background-image: url("+ nextArrow +");'></div>",
					prevArrow: "<div class='slick-arrow slick-prev' style='background-image: url("+ prevArrow +");'></div>"				
				});

				changePrivateDiningArea();

	            content.removeAttr('style');
	            content.removeClass('fading-out');

				if ( !changeArea && showSecondaryNav ) {
					if ( $('.restaurants-secondary-nav').hasClass('d-none') ) {
						$('.restaurants-secondary-nav').removeClass('fading-out');
						$('.restaurants-secondary-nav').removeClass('d-none');
					} else {
						$('.restaurants-pd-areas').removeClass('fading-out');
					}
				}
	        },
	        error : function (jqXHR, textStatus, errorThrown) {
	            $(this).html($.parseJSON(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
	            console.log(jqXHR);
	        },
	    }); 
	}

	// News events - Module
	$('.js__news-events-category').on('click', function(e) {
		if ( $(this).hasClass('active') ) {
			e.preventDefault();
		}
	});	

	// Restaurants Nav - Module
	if ( $('.restaurants__nav').length ) {
		var headerHeight = $('.m__header').outerHeight();
		var restaurantNavTop = $('.restaurants__nav').offset().top;

		$(window).on('scroll', function(e) {
			if ( $(window).scrollTop() >= restaurantNavTop - headerHeight ) {
				$('.restaurants__nav').css({'position': 'fixed', 'top': headerHeight, 'z-index': 3, 'width': '100%'});
			} else {
				$('.restaurants__nav').removeAttr('style');
			}
		});
	}

	$('.js__restaurant-nav-link').on('click', function(e) {
		e.preventDefault();

		var scrollSection = $(this).data('scroll-section');
		var restaurantNavHeight = $('.restaurants__nav').outerHeight();

	    var offset = headerHeight + restaurantNavHeight;

	    $('html, body').animate({
	        scrollTop: $('.'+scrollSection).offset().top - offset
	    }, 800);
	});	

	// Regional Focus Animation	
	if ( $('.region__svg-animation').length ) {
		var animationData = $('.regional__section').data('animation-json');
		var imagePath = $('.regional__section').data('image-path');		

		for (var i = 0; i < animationData.assets.length; i++) {
		  if (animationData.assets[i].u == 'images/') {
		    animationData.assets[i].u = imagePath;
		    break;
		  }
		}			

		var i = 1; $('.region__svg-animation').each(function() {
			$(this).attr('id','region__svg-animation-'+i);

		    var params = {
		        container: document.getElementById('region__svg-animation-'+i),
		        renderer: 'svg',
		        loop: false,
		        autoplay: false,
		        animationData: animationData
		    };

		    lottie.loadAnimation(params);

		    var anim;

		    $(window).on('scroll', function(e) {
		    	var windowTop = $(window).scrollTop();
		    	var windowBottom = windowTop + $(window).height();
			    var sectionTop = $('.regional__image.d-xl-block').offset().top;
			    var sectionHeight = $('.regional__image.d-xl-block').outerHeight();
			    var sectionMiddle = (sectionHeight / 2) + sectionTop; 

		    	if ( windowBottom > sectionMiddle ) {
	    			lottie.play();
		    	}
		    });		    

			i++;
		});
		/*var animationData = $('#region__svg-animation').data('animation-json');
		var imagePath = $('#region__svg-animation').data('image-path');

		for (var i = 0; i < animationData.assets.length; i++) {
		  if (animationData.assets[i].u == 'images/') {
		    animationData.assets[i].u = imagePath;
		    break;
		  }
		}	

	    var params = {
	        container: document.getElementById('region__svg-animation'),
	        renderer: 'svg',
	        loop: false,
	        autoplay: false,
	        animationData: animationData
	    };
	    lottie.loadAnimation(params);

	    var anim;

	    $(window).on('scroll', function(e) {
	    	var windowTop = $(window).scrollTop();
	    	var windowBottom = windowTop + $(window).height();
		    var sectionTop = $('.regional__image.d-xl-block').offset().top;
		    var sectionHeight = $('.regional__image.d-xl-block').outerHeight();
		    var sectionMiddle = (sectionHeight / 2) + sectionTop; 

	    	if ( windowBottom > sectionMiddle ) {
    			lottie.play();
	    	}
	    });*/
	}

	function getParameterByName(name, url) {
	    if (!url) url = window.location.href;
	    name = name.replace(/[\[\]]/g, '\\$&');
	    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
	        results = regex.exec(url);
	    if (!results) return null;
	    if (!results[2]) return '';
	    return decodeURIComponent(results[2].replace(/\+/g, ' '));
	}
}